import Swiper from 'swiper/dist/js/swiper'

const partnersSlider = (wrapper) => {
  if (!wrapper) return;

  const brandsSliderEl = wrapper.querySelector('.js-partners-slider');
  const slides = Array.prototype.slice.call(brandsSliderEl.querySelectorAll('.swiper-slide'));
  const pagination = wrapper.querySelector('.swiper-pagination');
  const slidesLength = slides.length;

  const partnersSliderSwiper = new Swiper(brandsSliderEl, {
    init: false,
    slidesPerView: 6,
    on: {
      init() {
        if (slidesLength <= 6) {
          $(brandsSliderEl).find('.swiper-wrapper').addClass("is-small");
          $(brandsSliderEl).find('.swiper-pagination').addClass("is-small");
        }
      }
    },
    pagination: {
      el: pagination,
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      599: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 6,
      }
    },
  });

  partnersSliderSwiper.init();

};

export default partnersSlider;
